export default __webpack_public_path__ + "static/media/verifyGuide.578631b6.pdf";